import { RefObject, useLayoutEffect } from "react";
import { isolateOverlayScroll, type IsolationMode } from "../utils/overlayScrollIsolation";

export function useOverlayScrollIsolation(
  rootRef: RefObject<HTMLElement | null>,
  enabled: boolean,
  mode: IsolationMode = "lock"
): void {
  useLayoutEffect(() => {
    if (!enabled) return;
    const root = rootRef.current;
    if (!root) return;
    return isolateOverlayScroll(root, mode);
  }, [enabled, mode, rootRef]);
}
